import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // lang: undefined, // 语言
        // version: "v3",// 版本
        // version: "v3.20.1220",
        version: undefined,

        language: {
            lang: undefined, //从url获取到的语言
            locale: undefined, //应用主体使用的语言
            privacy: undefined //隐私条款支持的语言
        }
    },
    mutations: {
        setLanguage(state, { lang, locale, privacy }) {
            if (lang) state.language.lang = lang;
            if (locale) state.language.locale = locale;
            if (privacy) state.language.privacy = privacy;
        },
        setVersion(state, version) {
            state.version = version;
        }
    },
    actions: {}
});



// WEBPACK FOOTER //
// ./src/store.js